import { downloadFile } from '@chatwoot/utils';

// ActiveStorage honours `?disposition=attachment` and propagates it to the
// signed storage URL, so direct navigation triggers a download instead of
// rendering the file inline.
export const buildAttachmentDownloadUrl = url => {
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('disposition', 'attachment');
    return parsed.toString();
  } catch {
    return url;
  }
};

const downloadThroughAnchor = url => {
  const link = Object.assign(document.createElement('a'), {
    href: buildAttachmentDownloadUrl(url),
    download: '',
    target: '_blank',
    rel: 'noopener noreferrer',
    style: 'display: none',
  });
  document.body.append(link);
  link.click();
  link.remove();
};

// downloadFile from @chatwoot/utils fetches the attachment via XHR, which
// fails when the storage host (S3, GCS, ...) does not allow CORS requests
// from the dashboard origin. Direct navigation is not subject to CORS, so
// fall back to an anchor click when the fetch-based download fails.
export const downloadAttachmentFile = async ({ url, type, extension }) => {
  if (!url) throw new Error('Invalid download parameters');

  try {
    await downloadFile({ url, type, extension });
  } catch {
    downloadThroughAnchor(url);
  }
};
